import { Stack, SvgIcon, Typography } from "@mui/material";

import { WindIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { NightReportMetric } from "interfaces/nightReport.interface";

import { MetricBadge } from "../../../../../NightReportScreen/components/MetricBadge";
import { StatCard } from "../components/StatCard";

type RespirationCardProps = {
  respiration: string | null;
  respirationMetric: NightReportMetric | null;
};

export function RespirationCard({
  respiration,
  respirationMetric,
}: RespirationCardProps) {
  const { t } = useTranslation();

  if (respiration === null) {
    return null;
  }

  return (
    <StatCard>
      <SvgIcon component={WindIcon} color={"neutral.decoration"} />
      <Typography
        variant={"bodySmallMedium"}
        sx={{
          color: "neutral.subtle",
        }}
      >
        {t("respiration_rate")}
      </Typography>
      <Stack direction={"row"} sx={{ alignItems: "baseline", gap: 0.5 }}>
        <Typography variant={"headingLargeRegular"}>{respiration}</Typography>
        <Typography
          variant={"headingSmallSemibold"}
          sx={{
            color: "neutral.subtle",
          }}
        >
          {t("rpm")}
        </Typography>
      </Stack>
      {respirationMetric?.deviation_pct && (
        <MetricBadge
          showPercent
          metric={respirationMetric}
          alertMetric={"respiration_rate"}
          delta={respirationMetric.deviation_pct}
          sx={{ alignSelf: "self-start" }}
        />
      )}
    </StatCard>
  );
}
